import './App.css';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { GlobalStyle } from './styles';
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
// import CookieConsentBlock from './components/CookieConsentBlock';
import Home from './components/pages/Home';
import Profile from './components/pages/Profile';
import Contact from './components/pages/Contact';
import Snippets from './components/pages/Snippets';
import SnippetPage from './components/pages/SnippetPage';
import Articles from './components/pages/Articles';
import ArticlePage from './components/pages/ArticlePage';
import Projects from './components/pages/Projects';
import ProjectPage from './components/pages/ProjectPage';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/snippets" element={<Snippets />} />
          <Route path="/snippets/:id" element={<SnippetPage />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectPage />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:slug" element={<ArticlePage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      {/* <CookieConsentBlock /> */}
    </Router>
  );
}

export default App;
